import { shareResource } from 'chameleon-src/queries';

/**
 * Saves resource sharing selected classes
 * @param {array} assignees The selected classes
 * @param {array} item Saved item
 * @param {array} items Saved items
 * @param {string} subject Subject ID
 * @param {Object} client Apollo client
 * @param {string} startsAt Start date
 * @param {string} dueAt Due date
 * @param {string} title Custom name
 * */
const shareResourceToClass = async (
  assignees,
  item = null,
  items = null,
  subject,
  client,
  startsAt,
  dueAt,
  title,
) => {
  const response = await client.mutate({
    mutation: shareResource,
    variables: {
      subject,
      startsAt,
      dueAt,
      title,
      resourceId: item ? item.resourceId : null,
      resourceIds: items.map((i) => i.resourceId),
      assignees,
      resourceType: item ? item.__typename : items[0].__typename,
    },
  });
  const { ok, errors, newAssignmentsNumber } =
    response.data.shareResourceWithClass;
  return { ok, errors, newAssignmentsNumber };
};

export default shareResourceToClass;
